import { render, staticRenderFns } from "./MoneyTransferBy.vue?vue&type=template&id=d3dde164&"
import script from "./MoneyTransferBy.vue?vue&type=script&lang=js&"
export * from "./MoneyTransferBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports